
import * as types from "../actions/siteTypes.js";
import * as actions from "../actions/siteActions.js";

import { call, put, takeEvery } from 'redux-saga/effects';
import axiosInstance from '../../interceptor/interceptor.js'; 


//FOR FETCHING SITES
function* fetchSiteSaga() {
    try {
      ////console.log("sitesaga")
        const response = yield call(axiosInstance.get, '/sites/list/');
        ////console.log(response.data);
        yield put(actions.fetchSiteSuccess(response.data.sites));
    } catch (error) {
        yield put(actions.fetchSiteFailure(error.message));
    }
}


// //FOR ADDING SITES
// function* addSiteSaga(action) {
//     try {
//         // Make the API call to add the sites
//         const response = yield call(axiosInstance.post, 'sites/create', action.payload );
//         ////console.log('site added successfully:', response.data);
//         if (response.data) {
//             // Dispatch a success action (you can add a success message or other needed data)
//             yield put(actions.addSiteSuccess());

//             // Trigger fetching of the site list after successfully adding the bank
//             yield put(actions.fetchSiteRequest());
//         } else {
//             // If something goes wrong, we can handle failure
//             yield put(actions.addSiteFailure('Failed to add the site'));
//         }
//     } catch (error) {
//         // Log the error and dispatch failure action
//         ////console.error('Error while adding site:', error);
//         //console.error('Error while adding sites:', error);
//         const errorMessage = error.response?.data?.message || 'An unexpected error occurred.';
//         //console.error('Error while adding visitor type:', errorMessage);
//         yield put(actions.addSiteFailure(error.message));
//     }
// }


function* addSiteSaga(action) {
  try {
      // Make the API call to add the site
      const response = yield call(axiosInstance.post, 'sites/create', action.payload);
      
      if (response.data) {
          // Dispatch success action and other necessary actions
          yield put(actions.addSiteSuccess());
      } else {
          // If no response data, handle failure
          yield put(actions.addSiteFailure('Failed to add the site'));
      }
  } catch (error) {
      // If error has a response, extract the message, else use a default error message
      const errorMessage = error.response?.data?.message || 'An unexpected error occurred.';
      //console.error('Error while adding site:', errorMessage);
      
      // Dispatch the failure action with the error message
      yield put(actions.addSiteFailure(errorMessage));
  }
}



//FOR UPDATING EMPLOYEE DETAILS
function* updateSiteSaga(action) {
    try {
     ////console.log('saga')
     ////console.log(action.payload)
  //    ////console.log(id)
    yield call(axiosInstance.patch, `/sites/update/${action.payload.id}`, action.payload);
  
      ////console.log('Updated Sites:', response.data);
      yield put(actions.updateSiteSuccess (action.payload));
    } catch (error) {
      yield put(actions.updateSiteFailure(error.message));
    }
  }


  //FOR DELETE SITES
function* deleteSiteSaga(action) {
    try {
      ////console.log(action.payload);
    const response = yield call(axiosInstance.patch, `/sites/toggle-status/${action.payload.id}`);
    ////console.log(response);
    ////console.log(response.data);
    
      // Check the response data to determine if the deletion was successful
      if (response.data) {
        //console.log( "deactivate" , response.data)
        const siteDeactivated = {
          siteId: action.payload.id,
          activated: response.data.activated, 
        };
     
        yield put(actions.deleteSiteSuccess(siteDeactivated)); 
      } else {
        
        yield put(actions.deleteSiteFailure('Failed to deactivate site'));
      }
    } catch (error) {
      yield put(actions.deleteSiteFailure(error.message)); 
    }
  }
  


export default function* watchFetchData()  {
    yield takeEvery(types.FETCH_SITE_REQUEST, fetchSiteSaga);
    yield takeEvery(types.ADD_SITE_REQUEST, addSiteSaga);
    yield takeEvery(types.UPDATE_SITE_REQUEST, updateSiteSaga);
    yield takeEvery(types.DELETE_SITE_REQUEST,deleteSiteSaga);
}
